module.exports = __webpack_public_path__ + "img/facebook.b4e3909c.png";